import type { Car } from '@multirx/shared';
import type { Driver } from '@multirx/shared';
import type { CarBackupFile, DriverBackupFile } from '@multirx/shared/game/garageBackup.js';
import {
  buildCarBackupFile,
  buildDriverBackupFile,
  carBackupEntryFromSaved,
  carBackupFilename,
  driverBackupEntryFromSaved,
  driverBackupFilename,
  parseCarBackupPayload,
  parseDriverBackupPayload,
} from '@multirx/shared/game/garageBackup.js';

function downloadJson(filename: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function exportCarsToFile(cars: Car[]): void {
  const file = buildCarBackupFile(cars.map((car) => carBackupEntryFromSaved(car)));
  downloadJson(carBackupFilename(new Date(file.exportedAt)), file);
}

export function exportDriversToFile(drivers: Driver[]): void {
  const file = buildDriverBackupFile(drivers.map((driver) => driverBackupEntryFromSaved(driver)));
  downloadJson(driverBackupFilename(new Date(file.exportedAt)), file);
}

export async function readCarBackupFromFile(file: File): Promise<CarBackupFile> {
  let raw: unknown;
  try {
    raw = JSON.parse(await file.text()) as unknown;
  } catch {
    throw new Error('Fichier JSON invalide');
  }
  return buildCarBackupFile(parseCarBackupPayload(raw));
}

export async function readDriverBackupFromFile(file: File): Promise<DriverBackupFile> {
  let raw: unknown;
  try {
    raw = JSON.parse(await file.text()) as unknown;
  } catch {
    throw new Error('Fichier JSON invalide');
  }
  return buildDriverBackupFile(parseDriverBackupPayload(raw));
}
